import { IHeading } from '@seb/web-design-system/core';

export function toHeading(cmp: { headline?: string; subline?: string }): IHeading {
  if (cmp.headline || cmp.subline) {
    return { title: cmp.headline, description: cmp.subline };
  }
  return undefined;
}
